import { Component, Input, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { DeltaItem } from '../models/delta-item.model';

@Component({
  selector: 'biz-view-delta-detail',
  templateUrl: './view-delta-detail.component.html',
  styleUrls: ['./view-delta-detail.component.scss']
})
export class ViewDeltaDetailComponent implements AfterViewChecked {
  @Input() item: DeltaItem | null = null;
  
  trackByIndex(index: number) { return index; }

  private expandedCells: { [key: string]: boolean } = {};
  truncatedCells: { [key: string]: boolean } = {};

  constructor(private cdr: ChangeDetectorRef) {}

  private cellKey(index: number, col: 'type' | 'jsonPath' | 'packageValue' | 'currentValue'): string {
    return `${index}-${col}`;
  }

  ngAfterViewChecked(): void {
    // Check which cells are truncated after view is rendered
    // Use setTimeout to defer updates outside the current change detection cycle
    setTimeout(() => {
      this.checkTruncatedCells();
    }, 0);
  }

  private checkTruncatedCells(): void {
    const elements = document.querySelectorAll('.text-ellipsis:not(.expanded)');
    let hasChanges = false;
    
    elements.forEach((el: Element) => {
      const htmlEl = el as HTMLElement;
      const key = htmlEl.getAttribute('data-cell-key');
      if (key) {
        // Check if element is truncated (scrollWidth > clientWidth)
        // Only update if not already marked as truncated to preserve the state
        if (!this.truncatedCells[key]) {
          const isTruncated = htmlEl.scrollWidth > htmlEl.clientWidth;
          if (isTruncated) {
            this.truncatedCells[key] = true;
            hasChanges = true;
          }
        }
      }
    });
    
    // Only trigger change detection if there were actual changes
    if (hasChanges) {
      this.cdr.detectChanges();
    }
  }

  toggleCell(index: number, col: 'type' | 'jsonPath' | 'packageValue' | 'currentValue'): void {
    const key = this.cellKey(index, col);
    // Toggle if the cell is truncated OR already expanded
    if (this.isTruncated(index, col) || this.isExpanded(index, col)) {
      this.expandedCells[key] = !this.expandedCells[key];
    }
  }

  isExpanded(index: number, col: 'type' | 'jsonPath' | 'packageValue' | 'currentValue'): boolean {
    return !!this.expandedCells[this.cellKey(index, col)];
  }

  isTruncated(index: number, col: 'type' | 'jsonPath' | 'packageValue' | 'currentValue'): boolean {
    return !!this.truncatedCells[this.cellKey(index, col)];
  }
  
  isClickable(index: number, col: 'type' | 'jsonPath' | 'packageValue' | 'currentValue'): boolean {
    // Show as clickable if truncated OR already expanded (so it can be collapsed)
    return this.isTruncated(index, col) || this.isExpanded(index, col);
  }
}
